import { Routes } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css']
})
export class LandingComponent implements OnInit {
  constructor() {}

  ngOnInit() {}

  register() {
    // this.router.redirectTo('/register');
  }
}



// WEBPACK FOOTER //
// ./src/app/landing/landing.component.ts